/** 进行微信分享初始化 */
import { i18n } from '@/i18n';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { setUpWeixinInit } from '@/utils/cache-setup-wx';
import { setWxShareInfo } from '@tencent/wphk-act-base-framework';
import { url } from '@tencent/wphk-base-utils';
import { computed, onMounted, ref, toRefs } from 'vue';
import { ShareConfigType, SHARE_CONFIG } from '../config/wx-share-config';
import { SHARE_URL_TAG } from '@tencent/wphk-components-wecoupon/components/share-channel/business/share-helper';
import { UrlParamKey, getUrlParamByKey } from '@/utils/url-params-helper';

// 是否微信分享信息设置成功
export const isWxShareInited = ref(false);

// 生成分享链接的规则：
// 1. 把普通券、连锁券的urlParam置空（或去掉）
// 2. 把adTag, ADTAG 改值 ： from_h5_share, from_copy_share, from_mp_share
// 3. 其他urlParam透传?————不透传了

// 疑问：分享动作需要把discountCode（来自线下物料）分享出去吗？
// 分享h5好友：直接是链接
// copy链接：使用端外中转页，需要限定透传的字段 - spId, adtag

const getShareLink = ({ spId, shareConfigType }: { spId: string, shareConfigType: ShareConfigType }) => {
  const { adtag, link } = SHARE_CONFIG[shareConfigType];
  /** 分享页面带上actType */
  const actType = getUrlParamByKey(UrlParamKey.actType);
  const shareLink = url.addUrlParams(link, {
    spId,
    ADTAG: adtag,
    fromtag: SHARE_URL_TAG,
    actType,
  });
  const finalLink = url.removeUrlParams(shareLink, [UrlParamKey.MTN, UrlParamKey.mtn, UrlParamKey.cdkey, 'vin', 'campaignid', 'batchid', 'inorex', 'targeturl']);
  return finalLink;
};

export type ShareLinkConfig = Record<ShareConfigType, string>;

export const useWxShare = () => {
  const { merchantConfig, spId } = toRefs(useMerchantInfo());
  // 分享链接
  const linkConfig: ShareLinkConfig = {
    wx: getShareLink({ spId: spId.value, shareConfigType: ShareConfigType.wx }),
    copy: getShareLink({ spId: spId.value, shareConfigType: ShareConfigType.copy }),
    mp: getShareLink({ spId: spId.value, shareConfigType: ShareConfigType.mp }),
  };
  const merchantName = computed(() => merchantConfig.value.mrchName || merchantConfig.value.mrchId);
  const copyContent = computed(() => i18n('我喺WeChat Pay HK發現merchantName獎賞好吸引：link', { merchantName: merchantName.value, link: linkConfig.copy }));
  const wxShareInfo = computed(() => ({
    title: i18n('立即嚟拎merchantName多款獎賞啦，先到先得！', { merchantName: merchantName.value }),
    desc: i18n('我喺WeChat Pay HK發現merchantName獎賞好吸引，一齊攞呀!', { merchantName: merchantName.value }),
    imgUrl: merchantConfig.value.mrchLogo,
  }));
  // 通用设置分享的方法
  const setCommonShareInfo = async () => {
    await setUpWeixinInit();
    handleSetWxShareInfo(linkConfig, wxShareInfo.value);
  };
  onMounted(async () => {
    // 设置微信分享信息,如果已设置，则不自动设置
    if (isWxShareInited.value) {
      return;
    }
    await setCommonShareInfo();
    isWxShareInited.value = true;
  });

  return {
    linkConfig,
    isWxShareInited,
    setCommonShareInfo,
    copyContent,
    wxShareInfo,
  };
};

/**
 * 设置微信分享内容
 * @param link 原链接 + adtag
 */
// eslint-disable-next-line max-len
// TODO: 判断ua，精确设置
function handleSetWxShareInfo(
  linkConfig: ShareLinkConfig,
  wxShareInfo: { title: string, desc: string, imgUrl: string },
) {
  setWxShareInfo({
    // 设置 h5 分享信息
    wx: {
      ...wxShareInfo, link: linkConfig.wx,
    },
    mp: {
      // 设置小程序分享信息
      title: wxShareInfo.title,
      link: linkConfig.mp,
      imgUrl: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20221216202259/mp-img-tiny.png',
    },
  });
}
